import FlexboxGrid from './FlexboxGrid';
import FlexboxGridItem from './FlexboxGridItem';

// export types
export type { FlexboxGridProps } from './FlexboxGrid';
export type { FlexboxGridItemProps } from './FlexboxGridItem';

// export components
export { FlexboxGrid, FlexboxGridItem };
export default FlexboxGrid;
